/**
 * Mapping of US area codes → friendly region label.  Used by the phone
 * field to render a small "📍 New Hampshire" hint as the user types.
 *
 * Coverage focuses on the Wireless Zone footprint (Northeast, plus the
 * country's 70 most-populous metros).  Falls back silently for unknown
 * codes — the hint just doesn't render.
 */
export const AREA_CODE_TO_REGION = {
  // ── New England (home territory) ──
  '603': 'New Hampshire',
  '207': 'Maine',
  '802': 'Vermont',
  '401': 'Rhode Island',
  '203': 'Connecticut', '475': 'Connecticut', '860': 'Connecticut', '959': 'Connecticut',
  '617': 'Boston, MA', '781': 'Boston suburbs, MA', '857': 'Boston, MA',
  '339': 'Eastern MA', '351': 'Eastern MA', '774': 'Southeastern MA',
  '413': 'Western MA', '508': 'Central MA', '978': 'Northern MA',
  // ── New York ──
  '212': 'New York City', '332': 'New York City', '347': 'NYC', '646': 'NYC',
  '718': 'NYC', '917': 'NYC', '929': 'NYC',
  '516': 'Long Island, NY', '631': 'Long Island, NY', '934': 'Long Island, NY',
  '914': 'Westchester, NY', '845': 'Hudson Valley, NY',
  '518': 'Albany, NY', '838': 'Albany, NY',
  '585': 'Rochester, NY', '716': 'Buffalo, NY',
  '315': 'Syracuse, NY', '607': 'Binghamton, NY', '680': 'Syracuse, NY',
  // ── New Jersey ──
  '201': 'North Jersey', '551': 'North Jersey', '973': 'North Jersey',
  '732': 'Central Jersey', '848': 'Central Jersey', '908': 'Central Jersey',
  '609': 'South Jersey', '640': 'South Jersey', '856': 'South Jersey',
  '862': 'North Jersey',
  // ── Pennsylvania ──
  '215': 'Philadelphia', '267': 'Philadelphia', '445': 'Philadelphia', '484': 'Lehigh Valley, PA',
  '610': 'Lehigh Valley, PA', '717': 'Harrisburg, PA', '223': 'Harrisburg, PA',
  '412': 'Pittsburgh', '724': 'Western PA', '878': 'Pittsburgh',
  '570': 'Northeast PA', '272': 'Northeast PA', '814': 'Central PA',
  // ── Mid-Atlantic ──
  '202': 'Washington, DC',
  '410': 'Baltimore', '443': 'Baltimore', '301': 'DC suburbs, MD', '240': 'DC suburbs, MD',
  '302': 'Delaware',
  '703': 'Northern Virginia', '571': 'Northern Virginia',
  '804': 'Richmond, VA', '757': 'Hampton Roads, VA',
  // ── Southeast ──
  '305': 'Miami', '786': 'Miami', '954': 'Fort Lauderdale', '561': 'Palm Beach, FL',
  '407': 'Orlando', '321': 'Central FL', '813': 'Tampa', '727': 'Tampa Bay, FL',
  '904': 'Jacksonville', '850': 'Tallahassee, FL',
  '404': 'Atlanta', '470': 'Atlanta', '678': 'Atlanta', '770': 'Atlanta',
  '704': 'Charlotte, NC', '980': 'Charlotte, NC', '919': 'Raleigh, NC', '984': 'Raleigh, NC',
  '843': 'Charleston, SC', '803': 'Columbia, SC',
  '615': 'Nashville', '629': 'Nashville', '901': 'Memphis',
  // ── Midwest ──
  '312': 'Chicago', '773': 'Chicago', '872': 'Chicago', '224': 'Chicago suburbs, IL',
  '847': 'Chicago suburbs, IL', '630': 'Chicago suburbs, IL', '331': 'Chicago suburbs, IL',
  '313': 'Detroit', '248': 'Detroit suburbs, MI', '586': 'Detroit suburbs, MI',
  '216': 'Cleveland', '614': 'Columbus, OH', '513': 'Cincinnati',
  '317': 'Indianapolis', '414': 'Milwaukee', '612': 'Minneapolis', '651': 'St. Paul, MN',
  // ── South Central / Southwest ──
  '214': 'Dallas', '469': 'Dallas', '972': 'Dallas suburbs, TX',
  '713': 'Houston', '281': 'Houston suburbs, TX', '832': 'Houston',
  '512': 'Austin', '737': 'Austin', '210': 'San Antonio', '726': 'San Antonio',
  '602': 'Phoenix', '480': 'Phoenix suburbs, AZ', '623': 'Phoenix suburbs, AZ',
  '702': 'Las Vegas', '725': 'Las Vegas',
  // ── West Coast ──
  '213': 'Los Angeles', '323': 'Los Angeles', '310': 'West LA', '424': 'West LA',
  '818': 'San Fernando Valley', '747': 'San Fernando Valley',
  '714': 'Orange County, CA', '657': 'Orange County, CA', '949': 'Orange County, CA',
  '619': 'San Diego', '858': 'San Diego', '760': 'San Diego County, CA',
  '415': 'San Francisco', '628': 'San Francisco',
  '510': 'East Bay, CA', '341': 'East Bay, CA',
  '408': 'Silicon Valley', '669': 'Silicon Valley',
  '503': 'Portland, OR', '971': 'Portland, OR',
  '206': 'Seattle', '253': 'Tacoma, WA', '425': 'Eastside, WA',
  // ── Mountain ──
  '303': 'Denver', '720': 'Denver', '801': 'Salt Lake City', '385': 'Salt Lake City',
};

export function regionForAreaCode(digits) {
  if (!digits || digits.length < 3) return null;
  return AREA_CODE_TO_REGION[digits.slice(0, 3)] || null;
}
